import { environmentDefaults } from './environment-defaults';
import * as defaultsDeep from 'lodash.defaultsdeep';

const override = {
  baseUrl: 'https://pioneer-service.dev.onyxcentersource.com',
  hostname: 'pioneer.dev.onyxcentersource.com',
  portalUrl: 'https://portal.dev.onyxcentersource.com',
  onyxGPImagesCommonDataUrl: 'https://cdn.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',
  allowApiDocs: true,
  emailValidation: true,
  cwr: {
    enable: true
  },
  agencyDashboardUrl: 'https://agency-dashboard.dev.onyxcentersource.com',
  showAgencyDashboard: false
};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.dev.ts